import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { canAddToCart } from "@insite/client-framework/Store/Pages/ProductDetails/ProductDetailsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme"; // Store Custom Code
import { breakpointMediaQueries } from "@insite/mobius/utilities"; // Store Custom Code
import ProductAddToCartButtonWithDispatch from "@store/Components/Marketing/ProductAddToCartButtonWithDispatch";
import { TYPOGRAPHY } from "@store/theme/design"; // Store Custom Code
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState, ownProps: HasProduct) => ({
    configurationSelection: state.pages.productDetails.configurationSelection,
    configurationCompleted: state.pages.productDetails.configurationCompleted,
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
    subscription: state.pages.productDetails.subscription,
});

export interface ProductDetailsAddToCartButtonStyles {
    button?: ButtonPresentationProps;
}

export const addToCartButtonStyles: ProductDetailsAddToCartButtonStyles = {
    button: {
        // Store Custom Code
        css: css`
            width: auto;
            min-width: 115px;
            font-size: ${TYPOGRAPHY.size.base};
            display: inline-block;
            height: 48px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 115px;
                            height: 40px;
                            margin: 0 !important;
                        `,
                        css``,
                        css`
                            max-width: 200px;
                            height: 48px;
                        `,
                        css``,
                        css``,
                    ],
                    "max",
                )}
        `,
    },
};

const styles = addToCartButtonStyles;

const ProductDetailsAddToCartButton = ({
    configurationSelection,
    configurationCompleted,
    variantSelectionCompleted,
    subscription,
}: Props) => {
    return (
        // Store Custom Code : This used to be ProductAddToCartButton
        <ProductAddToCartButtonWithDispatch
            configurationSelection={configurationSelection}
            configurationCompleted={configurationCompleted}
            variantSelectionCompleted={variantSelectionCompleted}
            subscription={subscription}
            extendedStyles={styles.button}
            data-test-selector="addProductToCart"
            analyticsId="Product Details Page"
        />
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps)(ProductDetailsAddToCartButton)),
    definition: {
        displayName: "Add to Cart Button",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
